<template>
    <revision-history :api-url="apiUrl" show-user-filter>
        <template #header="{ params }">
            <b-form-group
                :label="$t('Date')"
                class="mb-0"
                label-for="date"
            >
              <b-form-datepicker
                  id="date"
                  v-model="params.date"
                  :locale="$i18n.locale"
                  reset-button
              />
            </b-form-group>

            <b-form-group
                :label="$t('Filter by user')"
                class="mb-0 ml-3 mr-auto"
                label-for="filterByUser"
            >
                <b-input-group>
                    <resource-select
                        id="filterByUser"
                        v-model="user"
                        class="w-auto"
                        :resource="`projects/${projectId}/logs/users`"
                        no-custom-slots
                        eager
                        @input="params.user_id = $event ? $event.id : undefined"
                    />

                    <b-input-group-append>
                        <b-button @click="() => {user = null; params.user_id = undefined;}">
                            <fa :title="$t('Reset')" icon="times" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </template>
    </revision-history>
</template>

<script>
    import RevisionHistory from "@/components/RevisionHistory";
    import ResourceSelect from "@/components/selects/ResourceSelect";

    export default {
        name: 'ProjectLogsTab',
        components: {ResourceSelect, RevisionHistory},
        props: {
            projectId: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                user: null
            }
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/logs`
            },
        },
    };
</script>
